import { useTranslation } from "react-i18next";

const useKioskTranslation = () => {
  return useTranslation("", { keyPrefix: "kioskPage" });
};

export default useKioskTranslation;
